import { Flex } from '@grupoboticario/flora-react';
import { CheckCircleFillIcon } from '@grupoboticario/flora-react-icons';

import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';

export const SuccessInputMessage = ({ message }: { message: string }) => {
  return (
    <Flex align='center' css={{ position: 'relative', bottom: '$3' }} gap='$1'>
      <CheckCircleFillIcon size={16} color='$success-standard' />
      <ResponsiveFloraTypography
        fontSize='exceptionsAuxiliar'
        color='$nonInteractivePredominant'
        fontWeight='bold'
      >
        {message}
      </ResponsiveFloraTypography>
    </Flex>
  );
};
